/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DateSearchCountDTO interface.
 */
export function instanceOfDateSearchCountDTO(value) {
    return true;
}
export function DateSearchCountDTOFromJSON(json) {
    return DateSearchCountDTOFromJSONTyped(json, false);
}
export function DateSearchCountDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'requestDate': json['requestDate'] == null ? undefined : json['requestDate'],
        'scanCount': json['scanCount'] == null ? undefined : json['scanCount'],
    };
}
export function DateSearchCountDTOToJSON(json) {
    return DateSearchCountDTOToJSONTyped(json, false);
}
export function DateSearchCountDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'requestDate': value['requestDate'],
        'scanCount': value['scanCount'],
    };
}
